module.exports = __webpack_public_path__ + "img/gplay.a670c459.png";